"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PublicMetasService", {
    enumerable: true,
    get: function() {
        return PublicMetasService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
const _tableHelpers = require("~/helpers/tableHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let PublicMetasService = class PublicMetasService {
    async viewMetaGet(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.get(context).viewNotFound(param.sharedViewUuid);
        if (!await _models.View.verifyPassword(view, param.password)) {
            _catchError.NcError.get(context).invalidSharedViewPassword();
        }
        const base = await _models.Base.get(context, view.base_id);
        this.checkViewBaseType(view, base);
        view.lock_type = _nocodbsdk.ViewLockType.Collaborative;
        await view.getFilters(context);
        await view.getSorts(context);
        await view.getViewWithInfo(context);
        await view.getColumns(context);
        await view.getModelWithInfo(context);
        await view.model.getColumns(context);
        const source = await _models.Source.get(context, view.model.source_id);
        view.client = source.type;
        view.source = {
            id: source.id,
            type: source.type,
            is_meta: source.is_meta,
            is_local: source.is_local
        };
        // todo: return only required props
        view.password = undefined;
        // Required for Calendar Views
        const rangeColumns = [];
        if (view.type === _nocodbsdk.ViewTypes.CALENDAR) {
            for (const c of view.view.calendar_range){
                if (c.fk_from_column_id) {
                    rangeColumns.push(c.fk_from_column_id);
                } else if (c.fk_to_column_id) {
                    rangeColumns.push(c.fk_to_column_id);
                }
            }
        }
        view.model.columns = view.columns.filter((c)=>{
            const column = view.model.columnsById[c.fk_column_id];
            if (rangeColumns.includes(c.fk_column_id)) {
                return true;
            }
            // Check if column exists to prevent processing non-existent columns
            if (!column) return false;
            return c instanceof _models.GridViewColumn && c.group_by || c.show || column.rqd && !column.cdf && !column.ai || column.pk || view.model.columns.some((c1)=>(0, _nocodbsdk.isLinksOrLTAR)(c1.uidt) && c1.colOptions.type === _nocodbsdk.RelationTypes.BELONGS_TO && view.columns.some((vc)=>vc.fk_column_id === c1.id && vc.show) && c1.colOptions.fk_child_column_id === c.fk_column_id) || view.model.columns.some((c1)=>(_nocodbsdk.UITypes.Lookup === c1.uidt || _nocodbsdk.UITypes.Rollup === c1.uidt) && c1.colOptions && c1.colOptions.fk_relation_column_id === c.fk_column_id);
        }).map((c)=>new _models.Column(_extends({}, c, view.model.columnsById[c.fk_column_id])));
        const relatedMetas = {};
        // load related table metas
        for (const col of view.model.columns){
            await this.extractRelatedMetas(context, {
                col,
                relatedMetas
            });
        }
        // Some times related metas are null, so we need to filter them out
        for(const key in relatedMetas){
            if (relatedMetas[key] == null) delete relatedMetas[key];
        }
        view.relatedMetas = relatedMetas;
        if (view.model.columns.some((c)=>c.uidt === _nocodbsdk.UITypes.User || (0, _nocodbsdk.isCreatedOrLastModifiedByCol)(c))) {
            const baseUsers = await _models.BaseUser.getUsersList(context, {
                base_id: view.model.base_id
            });
            await _models.PresignedUrl.signMetaIconImage(baseUsers);
            view.users = baseUsers.map((u)=>({
                    id: u.id,
                    display_name: u.display_name,
                    email: u.email,
                    meta: (0, _nocodbsdk.ncIsObject)(u.meta) ? (0, _extractProps.extractProps)(u.meta, [
                        'icon',
                        'iconType'
                    ]) : null,
                    deleted: u.deleted
                }));
        }
        return view;
    }
    async extractRelatedMetas(context, { col, relatedMetas = {} }) {
        if ((0, _nocodbsdk.isLinksOrLTAR)(col.uidt)) {
            await this.extractLTARRelatedMetas(context, {
                ltarColOption: await col.getColOptions(context),
                relatedMetas
            });
        } else if (_nocodbsdk.UITypes.Lookup === col.uidt) {
            await this.extractLookupRelatedMetas(context, {
                lookupColOption: await col.getColOptions(context),
                relatedMetas
            });
        }
    }
    async extractLTARRelatedMetas(context, { ltarColOption, relatedMetas = {} }) {
        const { refContext, mmContext } = ltarColOption.getRelContext(context);
        relatedMetas[ltarColOption.fk_related_model_id] = await _models.Model.getWithInfo(refContext, {
            id: ltarColOption.fk_related_model_id
        });
        this.filterIfLimitedAccess(context, relatedMetas, ltarColOption.fk_related_model_id);
        if (ltarColOption.type === 'mm') {
            relatedMetas[ltarColOption.fk_mm_model_id] = await _models.Model.getWithInfo(mmContext, {
                id: ltarColOption.fk_mm_model_id
            });
            this.filterIfLimitedAccess(context, relatedMetas, ltarColOption.fk_mm_model_id);
        }
    }
    filterIfLimitedAccess(context, relatedMetas, tableId) {
        var _relatedMetas_tableId;
        if (((_relatedMetas_tableId = relatedMetas[tableId]) == null ? void 0 : _relatedMetas_tableId.columns) && !(0, _tableHelpers.hasDefaultTableVisibility)(tableId, context.permissions)) {
            relatedMetas[tableId].columns = relatedMetas[tableId].columns.filter((col)=>{
                return col.pk || col.pv;
            });
        }
    }
    async extractLookupRelatedMetas(context, { lookupColOption, relatedMetas = {} }) {
        var _relationCol_colOptions_getRelContext, _relationCol_colOptions;
        const relationCol = await _models.Column.get(context, {
            colId: lookupColOption.fk_relation_column_id
        });
        const { refContext = context } = ((_relationCol_colOptions = relationCol.colOptions) == null ? void 0 : (_relationCol_colOptions_getRelContext = _relationCol_colOptions.getRelContext) == null ? void 0 : _relationCol_colOptions_getRelContext.call(_relationCol_colOptions, context)) || {};
        const lookedUpCol = await _models.Column.get(refContext, {
            colId: lookupColOption.fk_lookup_column_id
        });
        // extract meta for table which belongs the relation column
        // if not already extracted
        if (!relatedMetas[relationCol.fk_model_id]) {
            relatedMetas[relationCol.fk_model_id] = await _models.Model.getWithInfo(context, {
                id: relationCol.fk_model_id
            });
            this.filterIfLimitedAccess(context, relatedMetas, relationCol.fk_model_id);
        }
        // extract meta for table in which looked up column belongs
        // if not already extracted
        if (!relatedMetas[lookedUpCol.fk_model_id]) {
            relatedMetas[lookedUpCol.fk_model_id] = await _models.Model.getWithInfo(refContext, {
                id: lookedUpCol.fk_model_id
            });
            this.filterIfLimitedAccess(context, relatedMetas, lookedUpCol.fk_model_id);
        }
        // extract metas related to the looked up column
        await this.extractRelatedMetas(refContext, {
            col: lookedUpCol,
            relatedMetas
        });
    }
    async publicSharedBaseGet(context, param) {
        const base = await _models.Base.getByUuid(context, param.sharedBaseUuid);
        if (!base) {
            _catchError.NcError.baseNotFound(param.sharedBaseUuid);
        }
        this.checkBaseType(base);
        return {
            base_id: base.id,
            base_title: base.title
        };
    }
    checkBaseType(_base) {
    // placeholder for future checks
    }
    checkViewBaseType(_view, _base) {
    // placeholder for future checks
    }
};
PublicMetasService = _ts_decorate([
    (0, _common.Injectable)()
], PublicMetasService);
